import React, { useState, useEffect, useRef } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import DriverCars from "./DriverCars";
import { BankDetails } from "./BannkDetails";
import UserRides from "./UserRides";
import UserWalletDetails from "./UserWalletDetails";
import UserInfoDetails from "./UserInfoDetails";
import { Typography } from "@mui/material";
import { C2, C2_FONT } from "../components/Table/C2UserTable";

const tabSx = {
  fontFamily: C2_FONT,
  fontWeight: 700,
  fontSize: 13,
  letterSpacing: 0.5,
  textTransform: "uppercase",
  minHeight: 48,
  color: C2.muted,
  "&.Mui-selected": { color: C2.violet },
};

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`driver-tabpanel-${index}`}
      aria-labelledby={`driver-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2.5 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `driver-tab-${index}`,
    "aria-controls": `driver-tabpanel-${index}`,
  };
}

export default function DriverDetails() {
  const { id } = useParams();
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const navigate = useNavigate();
  const loaded = useRef(false);

  useEffect(() => {
    if (staticusers) {
      const user = staticusers.filter(
        (user) => user.id === id.toString() && user.usertype === "driver"
      )[0];
      if (!user) {
        navigate("/404");
      }
      setData(user);
    } else {
      setData([]);
    }
    loaded.current = true;
  }, [staticusers, id, navigate]);

  return (
    <Box sx={{ width: "100%", bgcolor: C2.bg, minHeight: "100%", borderRadius: 2, p: { xs: 1.5, md: 2 } }}>
      <Box
        sx={{
          bgcolor: C2.white,
          borderRadius: "16px",
          border: `1px solid ${C2.border}`,
          px: 1,
          boxShadow: "0 4px 16px rgba(26,15,59,0.05)",
        }}
      >
        <Tabs
          value={value}
          onChange={(_, v) => setValue(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 48,
            "& .MuiTabs-indicator": {
              backgroundColor: C2.violet,
              height: 3,
              borderRadius: "3px 3px 0 0",
            },
          }}
        >
          <Tab sx={tabSx} label={<Typography sx={tabSx}>{t("info")}</Typography>} {...a11yProps(0)} />
          <Tab sx={tabSx} label={<Typography sx={tabSx}>{t("rides")}</Typography>} {...a11yProps(1)} />
          <Tab sx={tabSx} label={<Typography sx={tabSx}>{t("cars")}</Typography>} {...a11yProps(2)} />
          <Tab sx={tabSx} label={<Typography sx={tabSx}>{t("wallet")}</Typography>} {...a11yProps(3)} />
          <Tab sx={tabSx} label={<Typography sx={tabSx}>{t("bankDetails")}</Typography>} {...a11yProps(4)} />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <UserInfoDetails data={data} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <UserRides data={data} tabid={1} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <DriverCars data={data} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <UserWalletDetails data={data} id={1} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <BankDetails data={data} />
      </TabPanel>
    </Box>
  );
}
